import React from "react";
import { PUBLIC_FEATURES } from "../../lib/publicSite";

export default function Features() {
  return (
    <section className="max-w-7xl mx-auto px-6 py-16">
      <div className="max-w-2xl">
        <h1 className="font-display font-bold text-3xl sm:text-4xl">Everything a boutique owner actually needs.</h1>
        <p className="mt-3 text-lg" style={{ color: "var(--text-muted)" }}>
          No jargon. No dashboards that need a training class. Just the tools you already do on paper — but faster.
        </p>
      </div>
      <div className="mt-10 grid md:grid-cols-3 gap-5">
        {PUBLIC_FEATURES.map((f) => (
          <div key={f.title} className="card-soft p-6" data-testid={`landing-feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="w-11 h-11 rounded-md flex items-center justify-center mb-4" style={{ background: "var(--surface-tint)", color: "var(--primary)" }}>
              <f.icon size={22} strokeWidth={2.25} />
            </div>
            <div className="font-display font-semibold text-lg">{f.title}</div>
            <p className="mt-1.5 text-sm" style={{ color: "var(--text-muted)" }}>{f.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
